// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pPqB","version":"Footer_version__30hmx"};